import React from 'react'
import ReactDOM from 'react-dom'

import Data from './Data'
// Important, this becomes index.css
import '../../styles/index.less'

ReactDOM.render(<Data />, document.getElementById('root'))
